import Swal from 'sweetalert2'
import Dropzone from 'dropzone'

import { fileHtml } from './fileHtml'
import { lang } from '../../assets/lang'
import {
  handleDataOfDelay,
  handleOldDataOfDelay,
  sweetAlertCommonParams,
} from '../../utils/functions'

// eslint-disable-next-line
export const fileModal = async (oldData, node) => {
  const commonParams = sweetAlertCommonParams(node)
  
  return await Swal.fire({
    ...commonParams,
    title: lang.file_modal_title,
    html: fileHtml,

    willOpen: () => {
      const fileUploadMediaUrlElement = $('#file-upload-media-url')
      fileUploadMediaUrlElement.val(oldData.file || '')

      let serverGeneratedFilename = ''
      Dropzone.autoDiscover = false
      window.flowBuilderUploadedFileData = {}
      var base_url = window.xitFlowBuilderData.base_url

      const deleteUploadedFile = async (file) => {
        return await $.ajax({
          type: 'POST',
          url: base_url+'visual_flow_builder/flow_builder_delete_media',
          dataType: 'JSON',
          data: { file }, 
        })
      }

      // eslint-disable-next-line
      const uploadFileDropzone = new Dropzone("#file-upload-dropzone", {
        url: base_url+'visual_flow_builder/flow_builder_upload_media',
        maxFilesize: 20,
        uploadMultiple: false,
        paramName: "media_file",
        createImageThumbnails: true,
        acceptedFiles: ".doc, .docx, .pdf, .txt, .ppt, .pptx, .xls, .xlsx, .DOC, .DOCX, .PDF, .TXT, .PPT, .PPTX, .XLS, .XLSX",
        maxFiles: 1,
        addRemoveLinks: true,

        // eslint-disable-next-line
        success: async function(file, response) {
          // Display message if error
          if (false === response.status) {
            await Swal.fire({
              icon: 'error',
              text: response.message,
              title: 'Error!',
            });

            return
          }

          if (response.status) {
            serverGeneratedFilename = response.file

            window.flowBuilderUploadedFileData = {
              mime_type: response.mime_type,
              file: response.file,
            }

            fileUploadMediaUrlElement.val(response.file)
          }
        },

        // eslint-disable-next-line
        removedfile: function(file) {
          const fileData = window.flowBuilderUploadedFileData
          if (fileData.file && (fileData.file === serverGeneratedFilename)) {
            // eslint-disable-next-line
            const result = deleteUploadedFile(serverGeneratedFilename)
              .then(response => {
                if (response.status) {
                  window.flowBuilderUploadedFileData = {}
                  fileUploadMediaUrlElement.val('')
                  $('#file-upload-dropzone .dz-preview').remove()
                  Dropzone.forElement('#file-upload-dropzone').removeAllFiles(true)
                }
              }).catch(error => {
                if (error.status !== '200' && error.statusText) {
                  const message = error.status + ' ' + error.statusText
                  alert(message)
                } else {
                  console.log(error)
                }
              })
            
          }
        },
      })

      // Handles old data of Delay system
      handleOldDataOfDelay(oldData)

      // Removes previous files if there is any
      Dropzone.forElement('#file-upload-dropzone').removeAllFiles(true)
    },

    preConfirm: () => {
      const fileData = window.flowBuilderUploadedFileData
      const uploadedFile = $('#file-upload-media-url').val()

      if ((0 === Object.values(fileData).length)
        && node.data.mime_type
        && node.data.file
      ) {
        fileData.mime_type = node.data.mime_type
        fileData.file = node.data.file
      }

      if (uploadedFile) {
        fileData.file = uploadedFile
      }

      if (! uploadedFile && (Object.values(fileData).length !== 2)) {
        Swal.showValidationMessage(lang.file_modal_msg_file)
      }
      
      const delayData = handleDataOfDelay()

      return {
        ...fileData,
        ...delayData,
      }
    },    
  })
}